<template>
  <div class="translation-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.translations.title') }}</h1>
        <p>{{ $t('bo.translations.subtitle') }}</p>
      </div>
      <button @click="showCreate = true" class="btn-primary">
        {{ $t('bo.translations.newKey') }}
      </button>
    </div>

    <div class="tabs">
      <button :class="{ active: activeTab === 'list' }" @click="activeTab = 'list'">
        {{ $t('bo.translations.tabAllKeys') }}
      </button>
      <button :class="{ active: activeTab === 'missing' }" @click="activeTab = 'missing'">
        {{ $t('bo.translations.tabMissing') }}
      </button>
    </div>

    <TranslationKeysList
      v-if="activeTab === 'list'"
      ref="keysList"
      @edit="handleEdit"
    />

    <MissingTranslations
      v-if="activeTab === 'missing'"
    />

    <CreateTranslationKey
      v-if="showCreate"
      @close="showCreate = false"
      @created="handleCreated"
    />

    <EditTranslationKey
      v-if="editingKey"
      :key-id="editingKey"
      @close="editingKey = null"
      @updated="handleUpdated"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TranslationKeysList from './TranslationKeysList.vue'
import MissingTranslations from './MissingTranslations.vue'
import CreateTranslationKey from './CreateTranslationKey.vue'
import EditTranslationKey from './EditTranslationKey.vue'

const activeTab = ref('list')
const showCreate = ref(false)
const editingKey = ref(null)
const keysList = ref(null)

const handleEdit = (keyId) => {
  editingKey.value = keyId
}

const handleCreated = () => {
  showCreate.value = false
  activeTab.value = 'list'
  keysList.value?.loadKeys()
}

const handleUpdated = () => {
  editingKey.value = null
  keysList.value?.loadKeys()
}
</script>

<style scoped>
.translation-manager {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.tabs button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  transition: all 0.2s;
  margin-bottom: -2px;
}

.tabs button:hover {
  color: #3b82f6;
}

.tabs button.active {
  border-bottom-color: #3b82f6;
  color: #3b82f6;
  font-weight: 600;
}

.btn-primary {
  padding: 0.625rem 1.25rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}
</style>